import { generateAboutURL } from "../../../src/services/url";
import {
  CURRENCY,
  LOGO_URL,
  ACCCOUNT_FEES,
  EVENT_HANDLERS,
  LOCATION,
} from "../../constants";
import { LAYOUT_TYPE } from './Banner'
import {
  getInstallment,
  getTitles,
  isPromotionLengthValid,
  createQueryString,
  reviseWidgetSettings
} from "./utils";

export const Inversed = ({
  merchantId = "",
  currency = CURRENCY.AUD,
  containerClass = "",
  price,
  paymentOption,
  promotionMonths,
  productName,
  allowPriceBreakdown,
  defaultWidget,
  minAmount
}) => {
  const logoURL = LOGO_URL[currency];
  const accountFees = ACCCOUNT_FEES[currency];
  const { amount,amnt, length } = getInstallment(price, promotionMonths);

  let revised = reviseWidgetSettings({
    paymentOption,
    minAmount,
    price,
    allowPriceBreakdown,
    defaultWidget
  });

  allowPriceBreakdown = revised.allowPriceBreakdown;
  defaultWidget = revised.defaultWidget;
  
  const aboutURL = generateAboutURL(
    merchantId,
    currency,
    createQueryString(
      paymentOption,
      price,
      promotionMonths,
      allowPriceBreakdown,
      productName,
      LOCATION.WIDGET
    )
  );

  const { FALLBACK_TITLE, LEGACY_TITLE, PRICE_BREAKDOWN_TITLE } = getTitles({
    length,
    amount,
    amnt,
    price,
    currency,
    aboutURL,
    defaultWidget,
    layout: LAYOUT_TYPE.INVERSED
  });

  const title = allowPriceBreakdown
    ? PRICE_BREAKDOWN_TITLE
    : isPromotionLengthValid(length)
      ? FALLBACK_TITLE
      : LEGACY_TITLE;

  return `
  <!-- Latitude Interest Free Snippet - Start -->
  <div
    style="font-size: 14px; margin: 0; font-weight:450; display:flex;  max-width: 420px; flex-wrap: wrap; align-items: center;"
    class="${containerClass}">
    <img
        style="${currency === "AUD"
      ? `height:17px; margin-top: 10px; margin-bottom: 10px;`
      : `height:24px; align-self: center; margin-bottom: 5px;`
    } margin-right: 15px;"
        src="${logoURL}"
        alt="logo-${currency}"
        
      />
    ${title}
    ${!allowPriceBreakdown
      ? `
    <a
    id="lat-find-out"
    style="text-decoration:underline; cursor:pointer; color:inherit; margin-left: 10px;"
    target="_blank"
    onclick="${EVENT_HANDLERS.LEARN_MORE_CLICK}('${aboutURL}')"
  >
   Learn more
  </a>
        `
      : ""
    }
  </div>
  <!-- Latitude Interest Free Snippet - End -->
  `;
};